module.exports = __webpack_public_path__ + "img/2024_CellReports.e1adfdaf.png";